import { createFileRoute } from "@tanstack/react-router";
import { LexiconPage, lexiconHead } from "@/components/LexiconPage";

export const Route = createFileRoute("/sozluk/$")({
  head: () => lexiconHead("tr", { variant: "unknown" }),
  component: () => <LexiconPage lang="tr" />,
});
